import dayjs, { type Dayjs } from 'dayjs'

//
// 2021-01のような文字列を解析して、timeframe,format,dateを返す関数
// 具体的に期待している文字列は、実装参照
//

export function detect(
  dateString: string,
):
  | { timeframe: 'year' | 'month' | 'week' | 'day'; date: Dayjs; format: string }
  | { timeframe: 'fiscal_quarter' | 'fiscal_half' }
  | undefined {
  const replaced = dateString.replaceAll(/\d/gv, 'd')

  switch (replaced) {
    case 'dddd-dd-dd': {
      // (例) 2022-02-01
      const date = dayjs(dateString)
      const isValid = dateString === date.format('YYYY-MM-DD')
      return isValid ? { timeframe: 'day', format: 'YYYY-MM-DD', date } : undefined
    }
    case 'dddd-dd-ddW': {
      // (例) 2022-02-01W
      const date = dayjs(dateString.replace('W', ''))
      const isValid = dateString === `${date.format('YYYY-MM-DD')}W` && date.day() === 1 // 月曜日をチェック
      return isValid ? { timeframe: 'week', format: 'YYYY-MM-DD[W]', date } : undefined
    }
    case 'dddd-dd': {
      // (例) 2022-02
      const date = dayjs(`${dateString}-01`)
      const isValid = dateString === date.format('YYYY-MM')
      return isValid ? { timeframe: 'month', format: 'YYYY-MM', date } : undefined
    }
    case 'dddd-dQ': {
      // (例) 2022-1Q
      const isValid = /^\d{4}-[1-4]Q$/v.test(dateString)
      return isValid ? { timeframe: 'fiscal_quarter' } : undefined
    }
    case 'dddd-上半期':
    case 'dddd-下半期': {
      // (例) 2022-上半期
      const isValid = /^\d{4}-(?:上半期|下半期)$/v.test(dateString)
      return isValid ? { timeframe: 'fiscal_half' } : undefined
    }
    case 'dddd': {
      // (例) 2022
      const date = dayjs(`${dateString}-01-01`)
      const isValid = dateString === date.format('YYYY')
      return isValid ? { timeframe: 'year', format: 'YYYY', date } : undefined
    }
  }
}
